import { render, staticRenderFns } from "./FAQ.vue?vue&type=template&id=630a008c&scoped=true&"
var script = {}
import style0 from "./FAQ.vue?vue&type=style&index=0&id=630a008c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630a008c",
  null
  
)

export default component.exports